export const ACCESS_LEVEL = {NONE: 'none', READ: 'read', EDIT: 'edit'};